module.exports = __webpack_public_path__ + "static/media/dar.25dd75c9.png";